import { toWebSocketRequest, webSocketSend } from '@/utils/webSocket.util'
import { LogRequest } from '@/types/conductor'
import { LoggerLevel } from '@/types/conductorEnums'

// For developers only!
const FORCE_ON = false

const SERVICE_NAME_LOG_REQUEST = 'logRequest'
export const LOG_PREFIX_PERFORMANCE = 'PERFORMANCE'

let _sendLogsToServer = false
let _isSendingLogsToServer = false

let _showLogLogs = true
let _showInfoLogs = true
let _showWarnLogs = true
let _showErrorLogs = true
let _showLogGroups = true
let _showTimers = true
let _showPerformanceLogs = true

let _skipDebugLogging = false

export function setSendLogsToServer(sendLogsToServer: boolean) {
  _sendLogsToServer = sendLogsToServer
}

export function setShowLogLogs(showLogLogs: boolean) {
  _showLogLogs = FORCE_ON || showLogLogs
}

export function setShowInfoLogs(showInfoLogs: boolean) {
  _showInfoLogs = FORCE_ON || showInfoLogs
}

export function setShowWarnLogs(showWarnLogs: boolean) {
  _showWarnLogs = FORCE_ON || showWarnLogs
}

export function setShowErrorLogs(showErrorLogs: boolean) {
  _showErrorLogs = FORCE_ON || showErrorLogs
}

export function setShowLogGroups(showLogGroups: boolean) {
  _showLogGroups = showLogGroups
}

export function setShowTimers(showTimers: boolean) {
  _showTimers = showTimers
}

export function setShowPerformanceLogs(showPerformanceLogs: boolean): void {
  _showPerformanceLogs = showPerformanceLogs
}

export function setSkipDebugLogging(skipDebugLogging: boolean) {
  _skipDebugLogging = skipDebugLogging
}

const log = console.log
const info = console.info
const warn = console.warn
const error = console.error

const group = console.group
const groupCollapsed = console.groupCollapsed
const groupEnd = console.groupEnd

const time = console.time
const timeLog = console.timeLog
const timeEnd = console.timeEnd

console.log = (...data: any[]) => {
  if (_showLogLogs && !_skipDebugLogging) {
    log.apply(console, data)

    if (!_isSendingLogsToServer) {
      sendLogRequest(LoggerLevel.LOG, JSON.stringify(data))
    }
  }
}

console.info = (...data: any[]) => {
  if (_showInfoLogs) {
    info.apply(console, data)

    if (!_isSendingLogsToServer) {
      sendLogRequest(LoggerLevel.INFO, JSON.stringify(data))
    }
  }
}

console.warn = (...data: any[]) => {
  if (!_showWarnLogs) {
    return
  }

  warn.apply(console, data)

  // FIXME
  // [Vue warn] warnings are circular so can't send to JSON.stringify gets caught in recursive loop.
  // Can't send warnings to server until we finish move from to vue compat to Vue 3
  // if (!_isSendingLogsToServer) {
  // 	sendLogRequest(LoggerLevel.WARN, JSON.stringify(data))
  // }
}

console.error = (...data: any[]) => {
  if (_showErrorLogs) {
    error.apply(console, data)

    if (!_isSendingLogsToServer) {
      sendLogRequest(LoggerLevel.ERROR, JSON.stringify(data))
    }
  }
}

console.group = (...data: any[]) => {
  if (_showLogGroups && !_skipDebugLogging) {
    group.apply(console, data)

    if (!_isSendingLogsToServer) {
      sendLogRequest(LoggerLevel.GROUP, JSON.stringify(data))
    }
  }
}

console.groupCollapsed = (...data: any[]) => {
  if (_showLogGroups) {
    groupCollapsed.apply(console, data)

    if (!_isSendingLogsToServer) {
      sendLogRequest(LoggerLevel.GROUP, JSON.stringify(data))
    }
  }
}

console.groupEnd = () => {
  if (_showLogGroups && !_skipDebugLogging) {
    groupEnd.apply(console)
  }
}

console.time = (label?: string) => {
  if (_showTimers) {
    time(`TIMER: ${label}`)
  }
}

console.timeLog = (label?: string, ...data: any[]) => {
  if (_showTimers) {
    timeLog(`TIMER: ${label}`, data)
  }
}

console.timeEnd = (label?: string) => {
  if (_showTimers) {
    timeEnd(`TIMER: ${label}`)
  }
}

function logMeasure(measure: PerformanceEntry): void {
  if (_showPerformanceLogs) {
    console.info(
      `[${LOG_PREFIX_PERFORMANCE}] ${measure.name}: ${measure.duration}ms`,
    )
  }
}

export function logAllMeasures(): void {
  performance.getEntriesByType('measure').forEach((measureEntry) => {
    logMeasure(measureEntry)
  })
}

function sendLogRequest(level: string, message: string): void {
  if (_sendLogsToServer) {
    // Set a flag to not send any logs produced while in the method to the server.
    // Causes an infinite loop if removed.
    _isSendingLogsToServer = true
    console.groupCollapsed('sendLogRequest')

    const logRequest: LogRequest = {
      level,
      message,
    }
    console.log('logRequest: ', logRequest)

    const webSocketRequest: string = toWebSocketRequest(
      SERVICE_NAME_LOG_REQUEST,
      logRequest,
    )
    console.log(`webSocketRequest: ${webSocketRequest}`)

    console.info('Sending logRequest to WebSocket')
    // socket.socket.send(webSocketRequest);
    webSocketSend(webSocketRequest)

    console.groupEnd()
    _isSendingLogsToServer = false
  }
}
